import { render, staticRenderFns } from "./movie-list.vue?vue&type=template&id=37506875&scoped=true"
import script from "./movie-list.vue?vue&type=script&lang=js"
export * from "./movie-list.vue?vue&type=script&lang=js"
import style0 from "./movie-list.vue?vue&type=style&index=0&id=37506875&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37506875",
  null
  
)

export default component.exports